import React, { useState } from "react";
import "./form6.css";
import { useNavigate } from "react-router-dom";

const Form6 = ({ formData, setFormData, setStep }) => {
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  console.log(formData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.planet) newErrors.planet = "required";
    if (!formData.Year) newErrors.Year = "required";
    if (!formData.Month) newErrors.Month = "required";
    if (!formData.Day) newErrors.Day = "required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (validate()) { 
      setStep(7);
    }
  };

  const handleBack = () => {
    setStep(5);
  };

  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 1950 + 1 },
    (_, i) => currentYear - i
  );
  const months = Array.from({ length: 12 }, (_, i) =>
    (i + 1).toString().padStart(2, "0")
  );
  const dates = Array.from({ length: 31 }, (_, i) =>
    (i + 1).toString().padStart(2, "0")
  );

  return (
    <div className="form6-background">
      <div className="form6-section">
        <h2 className="form6-title">திசை இருப்பு (6/7)</h2>
        <form>
          <div className="form6-row">
            <div className="form6-group">
              <label>
                கிரகத்தைச் சேர்க்கவும் <span className="error fs-star">*</span>
              </label>
              <select
                name="planet"
                value={formData.planet}
                onChange={handleChange}
              >
                <option value="">கிரகத்தைத் தேர்வு செய்க</option>
                <option value="லக்னம்">லக்கனம்</option>
                <option value="சூரியன்">சூரியன்</option>
                <option value="சந்திரன்">சந்திரன்</option>
                <option value="செவ்வாய்">செவ்வாய்</option>
                <option value="புதன்">புதன்</option>
                <option value="குரு">குரு</option>
                <option value="சுக்ரன்">சுக்கிரன்</option>
                <option value="சனி">சனி</option>
                <option value="ராகு">ராகு</option>
                <option value="கேது">கேது</option>
              </select>
              {errors.planet && <span className="error-text">{errors.planet}</span>}
            </div>

            <div className="form6-group">
              <label>
                வருடம் <span className="error fs-star">*</span>
              </label>
                          <input type="text" className="form-control" name="Year" value={formData.Year} onChange={handleChange} />

              {errors.Year && <span className="error-text">{errors.Year}</span>}
            </div>

            <div className="form6-group">
              <label>
                மாதம் <span className="error fs-star">*</span>
              </label>
            <input type="text" className="form-control" name="Month" value={formData.Month} onChange={handleChange} />
              {errors.Month && <span className="error-text">{errors.Month}</span>}
            </div>

            <div className="form6-group">
              <label>
                நாள் <span className="error fs-star">*</span>
              </label>
            <input type="text" className="form-control" name="Day" value={formData.Day} onChange={handleChange} />
              {errors.Day && <span className="error-text">{errors.Day}</span>}
            </div>
          </div>

          <div className="form6-btn-group">
            <button type="button" className="back-btn-5" onClick={handleBack}>
              முன்செல்ல
            </button>
            <button type="button" onClick={handleNext} className="submit-btn-5">
              தொடர்க
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Form6;
